module.exports = __webpack_public_path__ + "static/img/TOYOTA.75a7766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/TOYOTA.png
// module id = dg4L
// module chunks = 1